import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Badge, Spinner } from "reactstrap";
import { getRuleLogsApi } from "../../apiServices/automationRule.services";

const RuleLogsModal = ({ isOpen, toggle, rule }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (isOpen && rule?._id) loadLogs(); }, [isOpen, rule]);

  const loadLogs = async () => {
    try {
      setLoading(true);
      const res = await getRuleLogsApi(rule._id);
      setLogs(res?.data?.records || []);
    } catch (err) { console.log(err); } finally { setLoading(false); }
  };

  const getActionBadge = (action) => {
    switch (action) {
      case "user_paused": return <Badge color="warning">⏸️ User Paused</Badge>;
      case "user_resumed": return <Badge color="success">▶️ User Resumed</Badge>;
      case "user_permanently_removed": return <Badge color="danger">🔴 Permanent Removal</Badge>;
      case "leads_transferred": return <Badge color="info">🔄 Leads Transferred</Badge>;
      case "leads_unassigned": return <Badge color="dark">⚠️ Leads Unassigned</Badge>;
      default: return <Badge color="secondary">{action}</Badge>;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}><i className="mdi mdi-history text-primary me-2" />Activity Logs — {rule?.ruleName || "Rule"}</ModalHeader>
      <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {loading ? <div className="text-center py-5"><Spinner color="primary" /></div> : !logs.length ? <div className="text-center py-4 text-muted">No activity logs recorded for this rule yet.</div> : (
          <Table className="align-middle table-striped table-bordered small">
            <thead className="table-light"><tr><th>Date & Time</th><th>Action</th><th>Target User</th><th>Performed By</th><th>Details / Message</th></tr></thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log._id}>
                  <td>{new Date(log.createdAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</td>
                  <td>{getActionBadge(log.action)}</td>
                  <td>{log.targetUser ? <strong>{log.targetUser.firstName} {log.targetUser.lastName}</strong> : "-"}</td>
                  <td>{log.performedBy ? <span>{log.performedBy.firstName} {log.performedBy.lastName}</span> : "System"}</td>
                  <td>
                    <div>{log.details?.message || log.reason || "-"}</div>
                    {log.transferToUser && <small className="text-primary d-block">Transferred to: {log.transferToUser.firstName} {log.transferToUser.lastName}</small>}
                    {log.affectedLeadsCount > 0 && <Badge color="info" className="mt-1">{log.affectedLeadsCount} Leads Affected</Badge>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter><Button color="light" onClick={toggle}>Close</Button></ModalFooter>
    </Modal>
  );
};

export default RuleLogsModal;
